module.exports = __webpack_public_path__ + "fonts/a0d6e9fc679907e6dcd66f679345ab78.svg";